import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Marker } from '../../interfaces/marker.interface';

@Injectable({
  providedIn: 'root'
})
export class MarkersService {
  private markers = new BehaviorSubject<Marker[]>([]);
  private selectedMarkerType = new BehaviorSubject<string | null>(null);
  private markerHistory: Marker[][] = [];

  private selectedMarkerSubject = new BehaviorSubject<{ name: string; url: string } | null>(null);
  selectedMarker$ = this.selectedMarkerSubject.asObservable();

  getMarkers(): Observable<Marker[]> {
    return this.markers.asObservable();
  }

  getSelectedMarkerType(): Observable<string | null> {
    return this.selectedMarkerType.asObservable();
  }

  setSelectedMarkerType(type: string | null): void {
    this.selectedMarkerType.next(type);
  }

  addMarker(marker: Marker): void {
    const currentMarkers = this.markers.value;
    this.markerHistory.push([...currentMarkers]);
    this.markers.next([...currentMarkers, marker]);
  }

  removeMarker(markerId: string): void {
    const currentMarkers = this.markers.value;
    this.markerHistory.push([...currentMarkers]);
    this.markers.next(currentMarkers.filter(marker => marker.id !== markerId));
  }

  clearMarkers(): void {
    this.markerHistory.push([...this.markers.value]);
    this.markers.next([]);
  }

  undo(): void {
    if (this.markerHistory.length > 0) {
      const previousState = this.markerHistory.pop();
      if (previousState) {
        this.markers.next(previousState);
      }
    }
  }

  setSelectedMarker(marker: { name: string; url: string } | null) {
    this.selectedMarkerSubject.next(marker);
  }

  getSelectedMarker() {
    return this.selectedMarkerSubject.value;
  }
}